/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui.inverted.segment[_ngcontent-%COMP%]{margin:0;border-radius:0;box-shadow:0 0 4px #222021;z-index:2}.column[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin:0}.one.wide.column[_ngcontent-%COMP%]{width:60px!important}h3[_ngcontent-%COMP%]{margin-bottom:5px!important}.angle.left.icon[_ngcontent-%COMP%]{margin-top:9px;margin-left:2px;margin-right:0;color:rgba(255,255,255,.7)}.angle.left.icon[_ngcontent-%COMP%]:hover{color:#fff}"];
export { styles as styles };
